import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import * as dataLayer from '@classic/Foundation/Analytics/AnalyticsDataLayer'

export const trackVenueModeHeaderClick = () => {
  trackEvent(dataLayer.keys.navigationClick, {
    interaction_type: 'Navigate to Venue Mode',
    location: 'Header',
  })
}
